{
  "NLAMS" : [
    {
      "name" : "Vletterlieden",
      "portAuthorityId" : "CVV"
    },
    {
      "name" : "Koperen Ploeg",
      "portAuthorityId" : "KOP"
    }
  ],
  "NLDZL" : [
    {
      "name" : "Bootliedenvereniging Delfzijl/Eemsh",
      "portAuthorityId" : "BVDE"
    }
  ],
  "NLHAR" : [
    {
      "name" : "B.D.S.",
      "portAuthorityId" : "BDS"
    },
    {
      "name" : "Nesta Shipping",
      "portAuthorityId" : "NEST"
    },
    {
      "name" : "Own Crew",
      "portAuthorityId" : "OWN CREW"
    },
    {
      "name" : "Shipdock Harlingen",
      "portAuthorityId" : "SHIPDOCK"
    }
  ],
  "NLRTM" : [
    {
      "name" : "Van Kuijk",
      "portAuthorityId" : "KUYK"
    },
    {
      "name" : "KRVE",
      "portAuthorityId" : "RVE"
    },
    {
      "name" : "V.I.O.S.",
      "portAuthorityId" : "VIOS"
    }
  ],
  "NLTNZ": [
    {
      "name": "Scheldt Maritime Services",
      "portAuthorityId": "SMS"
    }
  ],
  "NLVLI": [
    {
      "name": "Vlissingse Bootliedenwacht",
      "portAuthorityId": "VLB"
    }
  ]
}
